import { AuthErrorCodes } from '../../../types';
import { associateCartWithUser } from '../cart/associate-cart-with-user';
import { AUTH_IDENTIFY_ERROR, AUTH_IDENTIFY_REQUEST, AUTH_IDENTIFY_SUCCESS } from '../types';
export const identifyRequest = () => {
  return {
    type: AUTH_IDENTIFY_REQUEST
  };
};
/**
 * Action creator for AUTH_IDENTIFY_SUCCESS. It accepts either a string token OR
 * null, if the user is just not logged in.
 */
export const identifySuccess = token => {
  return {
    type: AUTH_IDENTIFY_SUCCESS,
    payload: {
      token
    }
  };
};
export const identifyError = function (error) {
  let meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: AUTH_IDENTIFY_ERROR,
    error: true,
    meta,
    payload: {
      error
    }
  };
};
export const getToken = () => {
  return async (dispatch, getState, _ref) => {
    let {
      auth
    } = _ref;
    try {
      dispatch(identifyRequest());
      const token = await auth.getToken();
      dispatch(identifySuccess(token));
      const {
        cart
      } = getState();
      if (cart.data.id && !cart.data.email) {
        try {
          await dispatch(associateCartWithUser());
        } catch (error) {
          console.error('Error associating cart with user', error);
        }
      }
      return token;
    } catch (error) {
      if (error.code !== AuthErrorCodes.Unauthorized) {
        dispatch(identifyError(error));
      } else if (error.code === AuthErrorCodes.Unauthorized) {
        dispatch(identifySuccess(null));
      }
      throw error;
    }
  };
};